import { BackupCeremony } from "@/features/recovery/backup-ceremony";

export default function RecoveryBackupPage() {
  return <BackupCeremony />;
}
